import type { EnsureOrganisationOutcome } from 'src/shared/state/api-slices/organisationEngineSlice';
import type { LegacyCustomer } from './findEstateDiscrepancies';

export type BulkOutcome = { kind: EnsureOrganisationOutcome } | { kind: 'failed'; reason: string };

export type BulkRun = {
    customers: LegacyCustomer[];
    outcomes: Map<string, BulkOutcome>;
    status: 'running' | 'finished' | 'stopped';
};

export type BulkFailure = { customer: LegacyCustomer; reason: string };

export const newRun = (customers: LegacyCustomer[]): BulkRun => ({
    customers: [...customers],
    outcomes: new Map(),
    status: 'running',
});

export const withOutcome = (run: BulkRun, customerId: string, outcome: BulkOutcome): BulkRun => ({
    ...run,
    outcomes: new Map(run.outcomes).set(customerId, outcome),
});

export const countOf = (run: BulkRun, kind: BulkOutcome['kind']) =>
    Array.from(run.outcomes.values()).filter(outcome => outcome.kind === kind).length;

export const failuresOf = (run: BulkRun): BulkFailure[] =>
    run.customers.flatMap(customer => {
        const outcome = run.outcomes.get(customer.customerId);
        return outcome?.kind === 'failed' ? [{ customer, reason: outcome.reason }] : [];
    });
